const updates = [
  { time: '10分钟前', title: '某知名导演新片选角内幕曝光，一线女星疑似被替换', tag: '独家', tagClass: 'bg-primary-100 text-primary-700' },
  { time: '28分钟前', title: '直播平台头部主播合约纠纷升级，平台方发布律师函', tag: '跟进', tagClass: 'bg-accent-100 text-accent-800' },
  { time: '45分钟前', title: '明星夫妇被曝疑似分居，双方工作室保持沉默', tag: '热议', tagClass: 'bg-secondary-100 text-secondary-800' },
  { time: '1小时前', title: '某偶像团体成员深夜发文暗示退团，粉丝集体崩溃', tag: '突发', tagClass: 'bg-primary-100 text-primary-700' },
  { time: '2小时前', title: '综艺节目录制现场设备故障，多位嘉宾受伤送医', tag: '快讯', tagClass: 'bg-accent-100 text-accent-800' },
  { time: '3小时前', title: '知名歌手新专辑被指抄袭，原作者发声要求下架', tag: '争议', tagClass: 'bg-secondary-100 text-secondary-800' },
  { time: '4小时前', title: '某电商主播带货翻车，消费者集体投诉产品质量问题', tag: '追踪', tagClass: 'bg-primary-100 text-primary-700' },
  { time: '5小时前', title: '娱乐圈资深经纪人离职内幕曝光，牵扯多位大牌艺人', tag: '深度', tagClass: 'bg-accent-100 text-accent-800' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新爆料动态
          </h2>
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent-500"></span>
          </span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">51吃瓜黑料网全天候追踪明星网红最新动态，不放过任何一个瓜</p>

        <div className="relative pl-8 md:pl-10">
          {/* Timeline line */}
          <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, idx) => (
              <div key={idx} className="relative">
                {/* Dot */}
                <div className={`absolute -left-[25px] md:-left-[31px] top-1.5 w-3 h-3 rounded-full border-2 border-background-100 ${
                  idx === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-300'
                }`}></div>

                <div className="bg-background-50 rounded-xl px-5 py-4 hover:bg-background-200/50 transition-colors cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-500 font-medium">{item.time}</span>
                    <span className={`px-1.5 py-0.5 text-xs font-medium rounded ${item.tagClass} whitespace-nowrap`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base font-medium text-foreground-800 leading-snug">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}